import request from '../../utilities/request';


/**
 * # Get Delivery Promise Text
 * Fetches standard delivery message data from API
 * @returns {object} The delivery message from API
 */
const getDeliveryPromiseText = async function () {

	return new Promise(async (resolve, reject) => {
		let deliveryText = {};
		let deliveryTextBackup = {
			deliveryPromiseText: 'Usually delivered within 4-5 days',
			deliveryMessage: '',
		}

        let deliveryPromiseText = await request.checkout.shippingMethod.deliveryPromise({methodCode: 'STD'})
			.then(data => data.json())
			.catch(err => {
				// default to 3-5 days standard delivery if something goes wrong
				resolve(deliveryTextBackup);
			});

		try {
			if (deliveryPromiseText.statusCode !== 0) {
				throw deliveryPromiseText;
			} else if (deliveryPromiseText?.response && deliveryPromiseText.response.statusCode === 0) {
				if (deliveryPromiseText?.response?.response?.deliveryPromiseText) {
					deliveryText.deliveryPromiseText = deliveryPromiseText.response.response.deliveryPromiseText;
					deliveryText.deliveryMessage = deliveryPromiseText.response.response.deliveryMessage;
				}
			}
		} catch (e) {
			resolve(deliveryTextBackup);
		}
    	resolve(deliveryText || deliveryTextBackup);
	});
}

export default getDeliveryPromiseText;
